import { Grid, Typography } from "@mui/material";

// One grid cell of an attestation row. The column headers only exist on desktop, so on mobile the
// label is repeated above the value.
const AttestationCell = ({ label, md, children }) => (
  <Grid
    item
    xs={12}
    md={md}
  >
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ display: { xs: "block", md: "none" } }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      component="div"
    >
      {children}
    </Typography>
  </Grid>
);

export default AttestationCell;
